export const INSIGHTS_SORT_ENABLED = 'INSIGHTS_SORT_ENABLED'
export const INSIGHTS_SORT_DISABLED = 'INSIGHTS_SORT_DISABLED'

export const enableInsightsSort = (sortField, order) => ({ type: INSIGHTS_SORT_ENABLED, sortField, order })

export const disableInsightsSort = () => ({ type: INSIGHTS_SORT_DISABLED })
